import { render, staticRenderFns } from "./SearchPolicyPayment.vue?vue&type=template&id=5b95aaba&"
import script from "./SearchPolicyPayment.vue?vue&type=script&lang=js&"
export * from "./SearchPolicyPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports